import { render, staticRenderFns } from "./TTCPolicyCheckbox.vue?vue&type=template&id=7ec8072c&"
import script from "./TTCPolicyCheckbox.vue?vue&type=script&lang=js&"
export * from "./TTCPolicyCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports